module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]), _vm._v(" "), _c('password-input', {
    ref: "password",
    attrs: {
      "options": {},
      "label": _vm.$t('profile.password.newPassword'),
      "model": _vm.passwords,
      "min-level": _vm.complexity
    },
    model: {
      value: (_vm.passwords.updated),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated", $$v)
      },
      expression: "passwords.updated"
    }
  }), _vm._v(" "), _c('password-input', {
    ref: "passwordAgain",
    attrs: {
      "options": {
        otherPassword: 'updated'
      },
      "label": _vm.$t('profile.password.newPasswordAgain'),
      "model": _vm.passwords,
      "min-level": _vm.complexity
    },
    model: {
      value: (_vm.passwords.updated2),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated2", $$v)
      },
      expression: "passwords.updated2"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf54f7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordForm.vue
// module id = 1049
// module chunks = 1